<template>
  <div class="conteudoTable">    
            <p  class="txtDadosG">Dados da NF-e</p>
            <div class="dadosGerais">
                <div v-for="(n,i) in table.dadosNfe" :key="i" :style="{'width':n.tamanho+'%'}"> 
                    <label for="">{{n.nome}}</label><br>
                    <input type="text" v-model="n.dado" readonly>
                </div>
            </div>
            <p  class="txtDadosG">Emitente</p>
            <div class="dadosGerais">
                <div v-for="(n,i) in table.emitente" :key="i" :style="{'width':n.tamanho+'%'}"> 
                    <label for="">{{n.nome}}</label><br>
                    <input type="text" v-model="n.dado" readonly>
                </div>
            </div>
            <p  class="txtDadosG">Destinatário</p>
            <div class="dadosGerais" style="flex-flow: column;">
                <div class="cortar">
                    <div v-for="(n,i) in table.destinatario" :key="i" :style="{'width':n.tamanho+'%'}" > 
                        <label for="">{{n.nome}}</label><br>
                        <input type="text" v-model="n.dado" readonly>
                    </div>
                </div>
                <div class="cortar">                
                    <div v-for="(n,i) in table.destinatario_b" :key="i" :style="{'width':n.tamanho+'%'}" > 
                        <label for="">{{n.nome}}</label><br>
                        <input type="text" v-model="n.dado" readonly>
                    </div>
                </div>
            </div>
            <p  class="txtDadosG">Emissão</p>
            <div class="dadosGerais" style="flex-flow: column;">
                <div class="cortar">
                    <div v-for="(n,i) in table.emissao" :key="i" :style="{'width':n.tamanho+'%'}"> 
                        <label for="">{{n.nome}}</label><br>
                        <input type="text" v-model="n.dado" readonly>
                    </div>
                </div>
                <div class="cortar">                
                    <div v-for="(n,i) in table.emissao_b" :key="i" :style="{'width':n.tamanho+'%'}" > 
                        <label for="">{{n.nome}}</label><br>
                        <input type="text" v-model="n.dado" readonly>
                    </div>
                </div>
            </div>
            <p  class="txtDadosG">Situação</p>            
            <div class="dadosGerais" >
                    <div class="tinta">
                        <label for="">Eventos</label><br>
                        <div v-for="(n,i) in table.situacao" :key="i"> 
                            <input type="text"  v-model="n.evento" readonly> 
                        </div>
                    </div>
                    <div class="tinta">  
                        <label for="">Texto</label><br>              
                        <div v-for="(n,i) in table.situacao" :key="i"> 
                            <input type="text"  v-model="n.protocolo" readonly> 
                        </div>
                    </div>
                    <div class="tinta">
                        <label for="">Data de Autorização</label><br>
                        <div v-for="(n,i) in table.situacao" :key="i"> 
                            <input type="text"  v-model="n.dataAutorizacao" readonly> 
                        </div>
                    </div>
                      <div class="tinta">
                        <label for="">Data de Inclusão</label><br>
                        <div v-for="(n,i) in table.situacao" :key="i"> 
                            <input type="text"  readonly> 
                        </div>
                    </div>
            </div>
        </div>
</template>

<script>
export default {   
    props:['table'],
    data(){
        return{
        
        }
    },  
}
</script>

<style>
.tinta{
    width: 24%;
}
</style>